export default "__VITE_ASSET__305fad31__"